export const CountriesOptions = (builder) => ({
    CountriesOptions: builder.mutation({
        query: ({ cname }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/get_country_code',
                method: 'GET',
                params: { cname },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});